import { render, staticRenderFns } from "./addOrderForm.vue?vue&type=template&id=23e742b6"
import script from "./addOrderForm.vue?vue&type=script&lang=js"
export * from "./addOrderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports